import { useTranslations as useOriginalTranslations } from 'next-intl';

type OriginalTranslator = ReturnType<typeof useOriginalTranslations>;

// Заменяем raw: (...args) => any на (...args) => unknown
// чтобы  не писать eslint-disable @typescript-eslint/no-unsafe-assignment по всему проекту
type TranslationFunction = ((
	...args: Parameters<OriginalTranslator>
) => ReturnType<OriginalTranslator>) &
	Omit<OriginalTranslator, 'raw'> & {
		raw: OriginalTranslator['raw'] extends (...a: infer P) => unknown
			? (...a: P) => unknown
			: never;
	};

// For future extensions
export function useTranslations(namespace?: string) {
	const t = useOriginalTranslations(namespace) as TranslationFunction;

	return t;
}
